const upperCaseTitles = ['xs', 'xl', 'xxl', 'xxxl', 'dvd', 'cd', 'usb'];

export default function (title = '') {
  return upperCaseTitles.includes(title.toLowerCase()) ?
    title.toUpperCase() :
    title;
}
